import React from 'react';

import useToken from 'components/Common/HeyGen/Hooks/useToken';
import PropTypes from 'prop-types';

import Loading from './Loading';
import Content from './Content';

export default function Main({ onClose, onCloseByTimeout, welcomeMessage }) {
  const token = useToken();

  return (
    <div className="ai-video-wrapper">
      {token === null ? <Loading /> : (
        <Content
          onClose={onClose}
          onCloseByTimeout={onCloseByTimeout}
          token={token}
          welcomeMessage={welcomeMessage}
        />
      ) }
    </div>
  );
}

Main.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCloseByTimeout: PropTypes.func.isRequired,
  welcomeMessage: PropTypes.string,
};

Main.defaultProps = {
  welcomeMessage: '',
};
